import { useGetDocumentExtractsByAccountQuery } from '@/services/genai';
import { Box, Spinner } from '@palmetto/palmetto-components';
import React, { useState } from 'react';

import { DocumentRendererFactory } from './documentRenderers';

interface AiAssistantAccountDocumentsAccordionProps {
  accountId: string;
}

export const AiAssistantAccountDocumentsAccordion: React.FC<AiAssistantAccountDocumentsAccordionProps> = ({
  accountId,
}) => {
  const { data: modelOutputs, isLoading, error, refetch } = useGetDocumentExtractsByAccountQuery(accountId);
  const [openPanels, setOpenPanels] = useState<Record<number, boolean>>({});

  if (isLoading) {
    return (
      <Box display="flex" justifyContent="center" padding="lg">
        <Spinner size="md" />
      </Box>
    );
  }

  if (error) {
    return (
      <Box padding="md">
        <Box color="danger-500" fontSize="md">
          Error loading document extracts: {error.toString()}
        </Box>
      </Box>
    );
  }

  if (!modelOutputs || modelOutputs.length === 0) {
    return (
      <Box padding="md">
        <Box color="grey-500" fontSize="md">
          No document extracts found for this account.
        </Box>
      </Box>
    );
  }

  return (
    <>
      {modelOutputs.map((modelOutput, panelIndex) => {
        const documentType = modelOutput.references?.documentType ?? modelOutput.references?.documentTypes?.[0];
        if (!documentType) return null;

        return (
          <DocumentRendererFactory
            key={modelOutput._id?.toString() || panelIndex}
            documentType={documentType}
            modelOutput={modelOutput}
            accountId={accountId}
            panelIndex={panelIndex}
            isOpen={openPanels[panelIndex] || false}
            onToggle={() => {
              setOpenPanels({ ...openPanels, [panelIndex]: !openPanels[panelIndex] });
            }}
            onRefresh={refetch}
          />
        );
      })}
    </>
  );
};
